import { initialize } from 'launchdarkly-js-client-sdk';

export function getLDClient(): { initialize: typeof initialize } {
  return { initialize };
}

type FeatureFlagGetter = (flag: string) => boolean;

let featureFlagGetter: FeatureFlagGetter | null = null;

export function setFeatureFlagGetter(getter: FeatureFlagGetter): void {
  featureFlagGetter = getter;
}

export function getFeatureFlag(flag: string): boolean {
  return featureFlagGetter?.(flag) ?? false;
}
